var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchWithAuth, fetchWithResponse } from './fetchHttpClient';
var ApiUrl = 'https://rich.customer-profile.vpsvc.com';
export function getBrands(authorization, requestor, includeSpeculations) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithResponse("".concat(ApiUrl, "/api/v2/customer/me/brand?includeSpeculations=").concat(includeSpeculations), authorization, requestor)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.brandProfiles];
            }
        });
    });
}
export function createBrand(authorization, createRequest, requestor) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithResponse("".concat(ApiUrl, "/api/v2/customer/me/brand"), authorization, requestor, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(createRequest),
                        })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.brandProfile];
            }
        });
    });
}
export function updateBrand(authorization, brandId, updateRequest, requestor) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithResponse("".concat(ApiUrl, "/api/v2/customer/me/brand/").concat(brandId), authorization, requestor, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(updateRequest),
                        })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.brandProfile];
            }
        });
    });
}
export function patchBrand(authorization, brandId, patchRequest, requestor) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithResponse("".concat(ApiUrl, "/api/v2/customer/me/brand/").concat(brandId), authorization, requestor, {
                            method: 'PATCH',
                            headers: { 'Content-Type': 'application/merge-patch+json' },
                            body: JSON.stringify(patchRequest),
                        })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.brandProfile];
            }
        });
    });
}
export function deleteBrand(authorization, brandId, requestor) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithAuth("".concat(ApiUrl, "/api/v2/customer/me/brand/").concat(brandId), authorization, requestor, { method: 'DELETE' })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function approveBrand(authorization, brandId, requestor) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithResponse("".concat(ApiUrl, "/api/v2/customer/me/brand/").concat(brandId, ":approve"), authorization, requestor, { method: 'POST' })];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.brandProfile];
            }
        });
    });
}
export function getLogoDetails(authorization, requestor, brandId, logoId) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!authorization) {
                        throw new Error('Authorization was undefined.');
                    }
                    return [4 /*yield*/, fetchWithResponse("".concat(ApiUrl, "/api/v2/customer/me/brand/").concat(brandId, "/logo/").concat(logoId, "/details"), authorization, requestor)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, data.logoDetails];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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